import React from "react";
import {connect} from "react-redux";
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import FilePicto from "../../Picto/FilePicto";
import FlecheDroiteMediumPicto from "../../Picto/FlecheDroiteMediumPicto";
import {donwloadFile} from "../../../API/API";
import WebView from "react-native-webview";

class PostFile extends React.Component{

    constructor(props) {
        super(props);
        this.download = this.download.bind(this);
        this.state = {
            downloadUrl:undefined
        }
    }


    resetUrlDonwload(){
        this.setState({
            downloadUrl:undefined
        })
    }



    download(){
        this.setState({
            downloadUrl:this.props.file.url
        });
    }

    render() {
        let name = this.props.file.name;


        const styles = StyleSheet.create({

            fileContainer:{
                flexDirection:"row",
                justifyContent:"space-between",
                backgroundColor: this.props.theme.colors.primary.blue5.value,
                borderRadius:5,
                marginVertical:3,
            },
            pictoFileContainer:{
                flexDirection:"row",
                justifyContent:"center",
                alignItems:"center",
            },
            picto:{
                marginVertical:5,
                marginHorizontal:15
            },
            fileName : {
                fontFamily : this.props.theme.fonts.text,
                fontSize:14,
                color : this.props.theme.colors.primary.blue1.value,
            }
        });

        return (
            <View>
                <TouchableOpacity onPress={this.download}>
                <View style={styles.fileContainer}>
                    <View style={styles.pictoFileContainer}>
                        <FilePicto style={[styles.picto,{width:19}]} isHeader={true}></FilePicto>
                        <Text style={styles.fileName}>{name}</Text>
                    </View>
                    <FlecheDroiteMediumPicto style={[styles.picto,{width:17}]} isHeader={true}></FlecheDroiteMediumPicto>
                </View>
                </TouchableOpacity>
            { this.state.downloadUrl != undefined && <WebView style={{width:0,height:0}}  source={{ uri: this.state.downloadUrl }} /> }
            </View>
        );
    }

}


const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(PostFile);
